import { BaseElementController } from '../../modules/BaseElementController';
import { Separator } from '../Separator/Separator';
import { SigningButtonController, SigningButtonControllerParams } from './SigningButtonController';
import { SigningButtonType } from './common';

import s from './SigningSection.scss';

export class SigningSectionController extends BaseElementController {
  private readonly signingButtonController: SigningButtonController;
  private readonly containerClassNames: string[] = [s.signingSectionContainer];

  constructor({ biLogger, config, t }: SigningButtonControllerParams) {
    super();
    this.signingButtonController = new SigningButtonController({ biLogger, config, t });
  }

  get containerClassName(): string {
    return this.containerClassNames.join(' ');
  }

  renderSignIn(): Element[] {
    return this.signingButtonController.render(SigningButtonType.SignIn);
  }

  renderLogInAndGetStarted(): Element[] {
    this.containerClassNames.push(s.twoButtons);
    return [
      this.createElementFromHTML(Separator({ className: s.separator })),
      ...this.signingButtonController.render(SigningButtonType.LogIn),
      ...this.signingButtonController.render(SigningButtonType.GetStarted),
    ];
  }

  toggleShadowDisplaying(show: boolean) {
    const container = this.$<HTMLDivElement>(`.${s.signingSectionContainer}`)!;
    container.classList[show ? 'add' : 'remove'](s.hasShadow);
  }
}
